import { render, staticRenderFns } from "./StockWarehouseContextBar.vue?vue&type=template&id=7b8542e4"
import script from "./StockWarehouseContextBar.vue?vue&type=script&lang=js"
export * from "./StockWarehouseContextBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports